import { HelpMessage } from 'utils/constants'
import { useNameColumn } from 'components/CIMSTable/common/hooks/useNameColumn'
import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import { Role } from '../../../RolesTableContext'
import PermissionViewer from '../../../../../components/PermissionViewer'
import { Permission, alphabeticalCompare, alphabeticalSort } from 'shared'

export const useColumns = (): CIMSColumn<Role>[] => {
  return [
    useNameColumn({
      help: HelpMessage.Administration.Roles.Name,
      width: 200,
      sort: { default: 'ascend' },
    }),
    {
      title: 'Permissions',
      width: 500,
      help: HelpMessage.Administration.Roles.Permissions,
      filter: {
        with: 'callback',
        items: [...Permission.pageToBasics.entries()]
          .sort(([a], [b]) => alphabeticalCompare(a.module, b.module, 'name'))
          .map(([{ id, name, module }, permissions]) => ({
            text: `${module.name}: ${name}`,
            value: id,
            children: permissions
              .sort(alphabeticalSort('name'))
              .map(({ name, id }) => ({
                text: name,
                value: id,
              })),
          })),
        onFilter: (val, { permissions }) => permissions.includes(val as string),
      },
      render: ({ permissions }) => (
        <PermissionViewer additionalPermissionIds={permissions} />
      ),
    },
  ]
}
